import CustomerVerificationButton from "./CustomerVerificationButton"

export default CustomerVerificationButton
